import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en';
import pt from './locales/pt';
import es from './locales/es';
import de from './locales/de';
import fr from './locales/fr';
import it from './locales/it';
import zh from './locales/zh';
import ja from './locales/ja';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pt: { translation: pt },
      es: { translation: es },
      de: { translation: de },
      fr: { translation: fr },
      it: { translation: it },
      zh: { translation: zh },
      ja: { translation: ja },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'scapow_lang',
    },
  });

export default i18n;

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English',  countryCode: 'GB' },
  { code: 'pt', label: 'Português', countryCode: 'PT' },
  { code: 'es', label: 'Español',  countryCode: 'ES' },
  { code: 'de', label: 'Deutsch',  countryCode: 'DE' },
  { code: 'fr', label: 'Français', countryCode: 'FR' },
  { code: 'it', label: 'Italiano', countryCode: 'IT' },
  { code: 'zh', label: '中文',      countryCode: 'CN' },
  { code: 'ja', label: '日本語',    countryCode: 'JP' },
] as const;
